import React from 'react';
//children
import LeftSection from './LeftSection';
import RightSection from './RightSection';
//style
import './Header.css';

const Header = (props) => (
  <div className="flex-container">
    <header>
      <LeftSection history={props.history} />
      <RightSection history={props.history} staticHeading ={props.staticHeading} />
    </header>
  </div>
)

export default Header;



// WEBPACK FOOTER //
// ./src/components/layouts/Header/Header.js